import { render, staticRenderFns } from "./AgesTable.vue?vue&type=template&id=9ffc5b46&scoped=true"
import script from "./AgesTable.vue?vue&type=script&lang=js"
export * from "./AgesTable.vue?vue&type=script&lang=js"
import style0 from "./AgesTable.vue?vue&type=style&index=0&id=9ffc5b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffc5b46",
  null
  
)

export default component.exports